import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ActoCondicionModel } from 'src/app/models/acto-condicion/ActoCondicionModel';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { IActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IActoCondicionModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ActoCondicionService } from 'src/app/services/acto-condicion/acto-condicion.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  templateUrl: './configuracion-acto-condicion-editar.component.html',
  styleUrls: ['./configuracion-acto-condicion-editar.component.css']
})
export class ConfiguracionActoCondicionEditarComponent implements OnInit {
  id: number = 0;
  model: IActoCondicionModel = new ActoCondicionModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceActoCondicion: ActoCondicionService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.serviceActoCondicion.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.serviceActoCondicion.update(this.model).subscribe((data) => {
            this.alertDialogService.open("El Acto - Condición fue actualizado");
            this.router.navigate(['/configuracion', 'actos-condicion']);  
          });
        }
      });
    }
  }
}
